import axios from 'axios';

const createAxiosInstance = (baseURL) => {
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        }
    });

    instance.interceptors.request.use(
        (config) => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user && user.token) {
                    config.headers['Authorization'] = 'Bearer ' + user.token;
                }
            } catch (error) {
                console.error('Error retrieving user from localStorage', error);
            }

            if (config.data instanceof FormData) {
                delete config.headers['Content-Type'];
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return instance;
};

//const apiInstance = createAxiosInstance('http://192.168.1.126:8097');
//const apiInstance = createAxiosInstance('https://apifinder.stelotechconsultingdev.com');
const apiInstance = createAxiosInstance('https://api.drivenhomeservices.com');
export default apiInstance;